import React, { FC, useEffect } from "react";
import styles from "./CarouselView.module.css";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { RxCross2 } from "react-icons/rx";
import photoOrdering from "../../photoOrdering.json";
import { escape } from "querystring";

interface CarouselViewProps {
  currentPhoto: string;
  setCarousel: Function;
  isDarkMode: boolean;
}

const CarouselView: FC<CarouselViewProps> = ({
  currentPhoto,
  setCarousel,
  isDarkMode,
}) => {
  const currentPhotoIndex = findPhotoIndex(currentPhoto);

  const isLeftArrowActive = currentPhotoIndex !== 0;
  const isRightArrowActive = currentPhotoIndex !== photoOrdering.length - 1;

  let widthLimit = setWidthLimiter();
  let heightLimit = setHeightLimiter();

  useEffect(() => {
    function updatePhotoSizeLimiters(): void {
      widthLimit = setWidthLimiter();
      heightLimit = setHeightLimiter();
    }

    window.addEventListener("resize", updatePhotoSizeLimiters);
    return () => window.removeEventListener("resize", updatePhotoSizeLimiters);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        escapeCarousel(setCarousel);
      } else if (e.key === "ArrowLeft" && isLeftArrowActive) {
        rotateCarousel(setCarousel, currentPhotoIndex, -1);
      } else if (e.key === "ArrowRight" && isRightArrowActive) {
        rotateCarousel(setCarousel, currentPhotoIndex, 1);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  });

  return (
    <div
      className={`${styles.CarouselView} ${isDarkMode ? styles.darkMode : ""}`}
    >
      <RxCross2
        className={styles.exit}
        onClick={() => updateCarousel(setCarousel, "")}
      />
      <div className={styles.flexContainer}>
        <IoIosArrowBack
          className={getArrowClassNames(isLeftArrowActive, true)}
          onClick={() => {
            if (isLeftArrowActive) {
              rotateCarousel(setCarousel, currentPhotoIndex, -1);
            }
          }}
        />
        <img src={`/pictures/large/${currentPhoto}`} />
        <IoIosArrowForward
          className={getArrowClassNames(isRightArrowActive, false)}
          onClick={() => {
            if (isRightArrowActive) {
              rotateCarousel(setCarousel, currentPhotoIndex, 1);
            }
          }}
        />
      </div>
    </div>
  );
};

function setWidthLimiter(): number {
  return window.innerWidth * 0.85;
}

function setHeightLimiter(): number {
  return window.innerHeight * 0.9;
}

function findPhotoIndex(photoName: string): number {
  return photoOrdering.findIndex((photo) => photo.name === photoName);
}

function changePhoto(currentPhotoIndex: number, indexChange: number): string {
  console.assert(currentPhotoIndex !== -1);
  console.assert(currentPhotoIndex !== 0 || indexChange !== -1);
  console.assert(
    currentPhotoIndex !== photoOrdering.length - 1 || indexChange !== 1
  );

  const nextPhoto =
    photoOrdering.at(currentPhotoIndex + indexChange)?.name ?? "";
  return nextPhoto;
}

function escapeCarousel(setCarousel: Function) {
  updateCarousel(setCarousel, "");
}

function rotateCarousel(
  setCarousel: Function,
  currentPhotoIndex: number,
  changeIndex: number
) {
  updateCarousel(setCarousel, changePhoto(currentPhotoIndex, changeIndex));
}

function rightCarousel(setCarousel: Function, currentPhotoIndex: number) {
  updateCarousel(setCarousel, changePhoto(currentPhotoIndex, 1));
}

function updateCarousel(setCarousel: Function, value: string): void {
  setCarousel(value);
}

function getArrowClassNames(isArrowActive: boolean, isLeft: boolean): string {
  return `${styles.arrow} ${
    isArrowActive ? styles.arrowActive : styles.arrowInactive
  } ${isLeft ? styles.leftArrow : styles.rightArrow}`;
}

export default CarouselView;
